// https://www.svgrepo.com/svg/469278/minimize-size
// https://svg2jsx.com/

export function MinimizeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      fill="#000"
      className="icon flat-line"
      data-name="Flat Line"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8.71 15.29L3 21M8.71 8.71L3 3m18 18l-5.71-5.71M21 3l-5.71 5.71"
      ></path>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 15h4a1 1 0 011 1v4"
        data-name="primary"
      ></path>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9 4v4a1 1 0 01-1 1H4"
        data-name="primary"
      ></path>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15 20v-4a1 1 0 011-1h4"
        data-name="primary"
      ></path>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20 9h-4a1 1 0 01-1-1V4"
        data-name="primary"
      ></path>
    </svg>
  );
}
